import { useState, useEffect } from "react";
import api from "@/lib/api";

export const contractKinds = (hidden = []) => [
  ...(hidden.includes("type-huur") ? [] : [["huur", "Huur"]]),
  ...(hidden.includes("tab-factoring") ? [] : [["factuur", "Factuur"]]),
  ...(hidden.includes("type-lening") ? [] : [["lening", "Lening"]]),
  ["overig", "Overig"],
];

export default function useHiddenModules() {
  const [hidden, setHidden] = useState([]);
  useEffect(() => {
    api.get("/catalog").then((r) => setHidden(Object.assign([...(r.data.hidden_modules || [])], { loaded: true }))).catch(() => setHidden(Object.assign([], { loaded: true })));
  }, []);
  return hidden;
}
